import { createContext } from 'react';

import { BaseComponentState } from 'lecture_pages/directives/components/base-lecture-component';

const BaseLectureComponentContext = createContext<BaseComponentState>(null);

export default BaseLectureComponentContext;
